module.exports = __webpack_public_path__ + "static/media/calendar.66bbcea2.jpg";